module.exports = __webpack_public_path__ + "img/projects_grey.01dd3122.svg";